export const getColorByValue = (value) => {
  if (value <= 8) return '#FF0000';
  if (value >= 9 && value <= 16) return '#FFA500';
  return '#008000';
};